import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/str-stores/my-account';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetAllMyAccountStoresSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get paginated user's stores.
 */
export const useGetAllMyAccountStores = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { setAllMyAccountStores, setIsLoadingAllMyAccountStores } = useData();

    const request = async () => {
        setIsLoadingAllMyAccountStores(true);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const error = new Error() as ApiError;

                try {
                    const json = await response.json();
                    error.message = json.message;
                    error.errors = json.errors;
                } catch (error: any) {
                    error.message = '';
                }
                
                error.statusCode = response.status;
                
                throw error;
            }

            const data: GetAllMyAccountStoresSuccessResponse = await response.json();

            setAllMyAccountStores(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
        } finally {
            setIsLoadingAllMyAccountStores(false);
        }
    };

    return { request };
};
